export const findStatusIssuedDocuments = (documents) => {
    if (documents !== undefined) {
        const findStatusDoc = documents?.some(item => item?.status === 'ISSUED'
            || item.status === 'WAIT_DISCHARGE'
            || item.status === 'RELEASED'
            || item.status === 'WAIT_CANCEL'
            || item.status === 'TO_SIGN_CAPTAIN'
            || item.status === 'TO_SIGN'
            || item.status === 'SIGNED_CAPTAIN'
            || item.status === 'TO_SIGN_CUSTOM')
        return findStatusDoc
    }
}
